import React, { memo } from 'react'
import { Link } from 'gatsby'

/**
 * Closing CTA band.
 *
 * Left-aligned rather than centred: the tag, then the statement, then a footer
 * row carrying the supporting line on one side and the actions on the other.
 *
 * The heading and supporting copy are unchanged.
 */
const Registration = () => (
  <section className="rg-section">
    <div className="rg-inner">
      <span className="rg-eyebrow">Start the conversation</span>

      <h2 className="rg-heading">
        You need it built right.<br />
        We make sure it stays that way.
      </h2>

      <div className="rg-foot">
        <p className="rg-sub">
          Every project we take on is a commitment — not just to ship software, but to deliver outcomes that hold up in production, under real users, over the long term. We measure our work by the quality our clients can stake their business on.
        </p>

        <div className="rg-actions">
          <Link to="/contact" className="rg-cta">
            Book a Free Consultation
          </Link>
          <Link to="/offers" className="rg-secondary">
            View all solutions &rarr;
          </Link>
        </div>
      </div>
    </div>
  </section>
)

export default memo(Registration)
